import SettingsSideNavigation from './view';

export default SettingsSideNavigation;
